/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_StoppingInputs */



/**
* | output |
* | --- |
* | "Getting your own account back…" |
*
* @param {Impersonation_StoppingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const impersonation_stopping = /** @type {((inputs?: Impersonation_StoppingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_StoppingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je krijgt je eigen account terug…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à votre propre compte…")
	return /** @type {LocalizedString} */ ("Getting your own account back…")
});